export default [
    {
        path: '/media-library',
        props: true,
        component: () => import('@/views/MediaLibrary'),
    },
];
